import { render, staticRenderFns } from "./Series.vue?vue&type=template&id=15f9a1a2&scoped=true"
import script from "./Series.vue?vue&type=script&lang=js"
export * from "./Series.vue?vue&type=script&lang=js"
import style0 from "./Series.vue?vue&type=style&index=0&id=15f9a1a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f9a1a2",
  null
  
)

export default component.exports